import { Section } from './Section.jsx';
import { T } from '../T.jsx';

// The three cards differ only in their accent variable pair and their copy, so
// they are data here rather than three near-identical blocks of markup. The
// data-i18n keys are copied verbatim from public/sections/features.html — they
// are looked up as-is and must not be regenerated.
const CARDS = [
  {
    icon: '✍️',
    glow: 'var(--glow-e)',
    accent: 'var(--accent-e)',
    titleKey: 'ml_feat_slides_title',
    title: 'Slide Creation',
    descKey: 'ml_feat_slides_desc',
    desc: `Build stunning presentations with an intuitive editor. Rich text, media embeds,
      code blocks, LaTeX equations, and beautiful theme support out of the box.`,
    items: [
      ['ml_feat_slides_1', 'Drag-and-drop slide builder'],
      ['ml_feat_slides_2', '6 professional themes'],
      ['ml_feat_slides_3', 'Markdown & LaTeX support'],
      ['ml_feat_slides_4', 'Media & code embedding'],
    ],
  },
  {
    icon: '\u{1F4FA}',
    glow: 'var(--glow-d)',
    accent: 'var(--accent-d)',
    titleKey: 'ml_feat_live_title',
    title: 'Live Presentation',
    descKey: 'ml_feat_live_desc',
    desc: `Present with confidence using real-time slide sync, audience engagement tools,
      and presenter notes. Students follow along on any device.`,
    items: [
      ['ml_feat_live_1', 'Real-time slide synchronization'],
      ['ml_feat_live_2', 'Live polls & Q&A'],
      ['ml_feat_live_3', 'Presenter notes & timer'],
      ['ml_feat_live_4', 'Multi-device audience view'],
    ],
  },
  {
    icon: '\u{1F916}',
    glow: 'var(--glow-i2)',
    accent: 'var(--accent-i2)',
    titleKey: 'ml_feat_ai_title',
    title: 'AI Assistance',
    descKey: 'ml_feat_ai_desc',
    desc: `Let AI help you create better lectures. Generate content, format slides
      intelligently, translate in real time, and create quizzes automatically.`,
    items: [
      ['ml_feat_ai_1', 'AI content generation'],
      ['ml_feat_ai_2', 'Smart slide formatting'],
      ['ml_feat_ai_3', 'Real-time translation'],
      ['ml_feat_ai_4', 'Auto quiz generation'],
    ],
  },
];

export function Features() {
  return (
    <Section>
      <section className="section" id="features">
        <T k="ml_features_label" className="section-label">Core Features</T>
        <T k="ml_features_heading" as="h2" className="section-heading fade-in">
          Everything You Need to Lecture Brilliantly
        </T>
        <T k="ml_features_intro" as="p" className="section-intro fade-in">
          MyLecture combines powerful slide creation tools, real-time presentation capabilities,
          and intelligent AI assistance into one seamless platform.
        </T>
        <div className="features-grid">
          {CARDS.map((card) => (
            <div className="feature-card fade-in" key={card.titleKey}>
              <div className="feature-icon" style={{ background: card.glow, color: card.accent }}>
                {card.icon}
              </div>
              <T k={card.titleKey} as="h3">{card.title}</T>
              <T k={card.descKey} as="p">{card.desc}</T>
              <ul>
                {card.items.map(([k, label]) => (
                  <T k={k} as="li" key={k}>{label}</T>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>
    </Section>
  );
}
